export default __webpack_public_path__ + "static/media/bebit.7b18ee90.png";